import request from './request';
import publicRequest from './publicRequest';
import firebase from 'firebase/app';
import 'firebase/auth';
import isOffline from './isOffline';

let fakeUser = {
	displayName:'Timpex Support',
	email:'support@timpex.no',
	photoUrl:null,
	uid:'olqPGTwLcXTq7qRZyoagzNZCark1',
};

let c = {};

c.init = async function(config) {
	if (isOffline()) {
		c.initPromise = Promise.resolve(fakeUser);
		return;
	}

	firebase.initializeApp(config);
	c.initPromise = new Promise((resolve) => {
		let cancel = firebase.auth().onAuthStateChanged(async(user) => {
			cancel();
			resolve(user);
		});
	});
};

c.lastRequest = { validTo: 0, result: undefined };

c.signOut = async function() {
	if (isOffline())
		return;

	await c.initPromise;
	await firebase.auth().signOut();
	c.lastRequest = { validTo: 0, result: undefined };
};

c.verifyUserHasAccess = async function() {
	if (isOffline())
		return { notLoggedIn: false, notVerified: false, superUser: true };

	await c.initPromise;
	if (await c.userNotLoggedIn()) {
		return { notLoggedIn: true, notVerified: true, superUser: false };
	} else if (await c.userNotVerifiedEmail()) {
		return { notLoggedIn: false, notVerified: true, superUser: false };
	}
	let superUser = await c.userIsSuper();
	return { notLoggedIn: false, notVerified: false, superUser: superUser };
};

c.onUserStateChanged = async function(cb) {
	if (isOffline()) {
		cb(fakeUser);
		return;
	}
	firebase.auth().onAuthStateChanged(async(user) => {
		cb(user);
	});
};

c.getCurrentUser = async function() {
	if (isOffline())
		return fakeUser;

	await c.initPromise;
	return firebase.auth().currentUser;
};

c.getIdToken = async function() {
	if (isOffline())
		return 'fakeToken';

	await c.initPromise;
	let user = firebase.auth().currentUser;
	if (!user) {
		return null;
	}
	let token = await user.getIdToken();
	return token;
};

c.userNotVerifiedEmail = async function() {
	if (isOffline())
		return false;

	await c.initPromise;
	firebase.auth().currentUser.reload();
	let user = firebase.auth().currentUser;
	if (user) {
		return !user.emailVerified;
	} else {
		return null;
	}
};

c.userIsSuper = async function(noLog = false) {
	if (isOffline())
		return false;

	await c.initPromise;
	/*
	 *result={super:true||false}||undefined
	 *!undefined=true=>noAccess, !{super:true||false}=false=>Access
	 */
	let transporterCode = localStorage.getItem('transporterCode');
	let isSuper = c.lastRequest.result;
	if (transporterCode && (c.lastRequest.validTo < new Date().valueOf() || !c.lastRequest.result)) {
		try {
			let res = await request({
				method: 'get',
				url: `/users/currentUser/isSuper?noLog=${noLog}`,
			});
			isSuper = res;
			c.lastRequest.result = isSuper;
			c.lastRequest.validTo = new Date().valueOf() + 30000;
		} catch (e) {
			return false;
		}
	}
	return isSuper.super;
};

c.userNotLoggedIn = async function() {
	if (isOffline())
		return false;

	await c.initPromise;
	let currentUser = await firebase.auth().currentUser;
	let notLoggedIn = true;
	if (currentUser !== undefined && currentUser !== null) {
		notLoggedIn = false;
	}
	return notLoggedIn;
};

// c.resetPasswordEmail = async function(email) {
// 	if (isOffline())
// 		return Promise.resolve();

// 	await c.initPromise;
// 	return await request({
// 		method: 'post',
// 		url: 'users/currentUser/changePassword'
// 	});
// };

c.sendEmailVerification = async function() {
	if (isOffline())
		return Promise.resolve();

	await c.initPromise;
	return publicRequest({
		method: 'post',
		url: 'users/sendVerificationEmail'
	});
};

c.userLastLogin = async function() {
	if (isOffline())
		return { lastLogin: new Date().toISOString() };

	await c.initPromise;
	let lastLogin = await request({
		method: 'get',
		url: '/users/currentUser/lastLogin'
	});
	return lastLogin;
};

c.updateLastLogin = async function() {
	if (isOffline())
		return;

	await c.initPromise;
	await request({
		method: 'post',
		url: '/users/currentUser/lastLogin'
	});
};

c.auth = firebase.auth;

export default c;
